/* eslint-disable */
import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';

import * as products from './assets/products';
import * as socials from './assets/socials';
import * as mainPage from './assets/mainPage';
import * as conceirge from './assets/concierge';
import * as general from './assets/general';

import { ISvg } from './assets/Svg';

export enum Name {
  PRODUCTS_APP_TEMPLATES = 'PRODUCTS_APP_TEMPLATSE',
  PRODUCTS_VISUAL_APP_BUILDER = 'PRODUCTS_VISUAL_APP_BUILDER',
  PRODUCTS_IN_BROWSER_APP_PREVIEW = 'PRODUCTS_IN_BROWSER_APP_PREVIEW',
  PRODUCTS_CONTINIOUS_INTEGRATION = 'PRODUCTS_CONTINIOUS_INTEGRATION',
  PRODUCTS_BACKEND_AS_A_SERVICE = 'PRODUCTS_BACKEND_AS_A_SERVICE',
  PRODUCTS_APP_LANDING_PAGE = 'PRODUCTS_APP_LANDING_PAGE',
  PRODUCTS_STORE_MANAGER = 'PRODUCTS_STORE_MANAGER',
  PRODUCTS_SCREENSHOTS_GENERATOR = 'PRODUCTS_SCREENSHOTS_GENERATOR',
  PRODUCTS_TERMS_AND_POLICES_GENERATOR = 'PRODUCTS_TERMS_AND_POLICES_GENERATOR',
  PRODUCTS_CMS = 'PRODUCTS_CMS',
  PRODUCTS_CODEPLATFORM_AI = 'PRODUCTS_CODEPLATFORM_AI',

  SOCIALS_LINKEDIN = 'SOCIALS_LINKEDIN',
  SOCIALS_GITHUB = 'SOCIALS_GITHUB',
  SOCIALS_YOUTUBE = 'SOCIALS_YOUTUBE',

  MAIN_PAGE_DISCOVER_RUN_PREVIEW = 'MAIN_PAGE_DISCOVER_RUN_PREVIEW',
  MAIN_PAGE_DISCOVER_APP_STARTER = 'MAIN_PAGE_DISCOVER_APP_STARTER',
  MAIN_PAGE_DISCOVER_VIDEO_CONTENT_APP = 'MAIN_PAGE_DISCOVER_VIDEO_CONTENT_APP',
  MAIN_PAGE_DISCOVER_CHAT_OR_MESSENGER = 'MAIN_PAGE_DISCOVER_CHAT_OR_MESSENGER',
  MAIN_PAGE_DISCOVER_CHAT_GPT = 'MAIN_PAGE_DISCOVER_CHAT_GPT',

  CONCIERGE_FEATURES = 'CONCIERGE_FEATURES',
  CONCIERGE_INTEGRATIONS = 'CONCIERGE_INTEGRATIONS',
  CONCIERGE_LEGACY = 'CONCIERGE_LEGACY',
  CONCIERGE_MOBILE_DEVELOPMENT = 'CONCIERGE_MOBILE_DEVELOPMENT',
  CONCIERGE_UX = 'CONCIERGE_UX',
  CONCIERGE_WEB_DEVELOPMENT = 'CONCIERGE_WEB_DEVELOPMENT',

  GENERAL_FEATURE_CHECK_MARK = 'GENERAL_FEATURE_CHECK_MARK',
  GENERAL_FEATURE_ARROW = 'GENERAL_FEATURE_ARROW',
  GENERAL_FEATURE_ARROW_SECOND = 'GENERAL_FEATURE_ARROW_SECOND',
  GENERAL_HARDEST_ROUND = 'GENERAL_HARDEST_ROUND',
  GENERAL_HIDE_PASSWORD = 'GENERAL_HIDE_PASSWORD',
  GENERAL_PLANS_CHECK_MARK = 'GENERAL_PLANS_CHECK_MARK',
  GENERAL_PRICING_TABLE_INFO = 'GENERAL_PRICING_TABLE_INFO',
  GENERAL_PRICING_TABLE_CHECK_MARK = 'GENERAL_PRICING_TABLE_CHECK_MARK',
  GENERAL_PRICING_TABLE_CROSS = 'GENERAL_PRICING_TABLE_CROSS',
}

interface IIcon extends ISvg {
  name: Name;
  color?: string;
}

const IconByName: React.FC<IIcon> = ({ name, ...props }) => {
  switch (name) {
    case Name.PRODUCTS_APP_TEMPLATES:
      return <products.AppTemplates {...props} />;
    case Name.PRODUCTS_VISUAL_APP_BUILDER:
      return <products.VisualAppBuilder {...props} />;
    case Name.PRODUCTS_IN_BROWSER_APP_PREVIEW:
      return <products.InBrowserAppsPreview {...props} />;
    case Name.PRODUCTS_CONTINIOUS_INTEGRATION:
      return <products.ContinuousIntegration {...props} />;
    case Name.PRODUCTS_BACKEND_AS_A_SERVICE:
      return <products.BackendAsAService {...props} />;
    case Name.PRODUCTS_APP_LANDING_PAGE:
      return <products.AppLandingPage {...props} />;
    case Name.PRODUCTS_STORE_MANAGER:
      return <products.StoreManager {...props} />;
    case Name.PRODUCTS_SCREENSHOTS_GENERATOR:
      return <products.ScreenshotsGenerator {...props} />;
    case Name.PRODUCTS_TERMS_AND_POLICES_GENERATOR:
      return <products.TermsAndPoliciesGenerator {...props} />;
    case Name.PRODUCTS_CMS:
      return <products.CMS {...props} />;
    case Name.PRODUCTS_CODEPLATFORM_AI:
      return <products.CodeplatformAI {...props} />;

    case Name.SOCIALS_LINKEDIN:
      return <socials.LinkedIn {...props} />;
    case Name.SOCIALS_GITHUB:
      return <socials.GitHub {...props} />;
    case Name.SOCIALS_YOUTUBE:
      return <socials.Youtube {...props} />;

    case Name.MAIN_PAGE_DISCOVER_RUN_PREVIEW:
      return <mainPage.RunPreview {...props} />;
    case Name.MAIN_PAGE_DISCOVER_APP_STARTER:
      return <mainPage.AppStarter {...props} />;
    case Name.MAIN_PAGE_DISCOVER_VIDEO_CONTENT_APP:
      return <mainPage.VideoContentApp {...props} />;
    case Name.MAIN_PAGE_DISCOVER_CHAT_OR_MESSENGER:
      return <mainPage.ChatOrMessenger {...props} />;
    case Name.MAIN_PAGE_DISCOVER_CHAT_GPT:
      return <mainPage.ChatGPT {...props} />;

    case Name.CONCIERGE_FEATURES:
      return <conceirge.Features {...props} />;
    case Name.CONCIERGE_INTEGRATIONS:
      return <conceirge.Integrations {...props} />;
    case Name.CONCIERGE_LEGACY:
      return <conceirge.Legacy {...props} />;
    case Name.CONCIERGE_MOBILE_DEVELOPMENT:
      return <conceirge.MobileDevelopment {...props} />;
    case Name.CONCIERGE_UX:
      return <conceirge.UX {...props} />;
    case Name.CONCIERGE_WEB_DEVELOPMENT:
      return <conceirge.WebDevelopment {...props} />;

    case Name.GENERAL_FEATURE_CHECK_MARK:
      return <general.FeatureCheckMark {...props} />;
    case Name.GENERAL_FEATURE_ARROW:
      return <general.FeatureArrow {...props} />;
    case Name.GENERAL_FEATURE_ARROW_SECOND:
      return <general.FeatureArrowSecond {...props} />;
    case Name.GENERAL_HARDEST_ROUND:
      return <general.HardestRound width={1440} height={85} {...props} />;
    case Name.GENERAL_HIDE_PASSWORD:
      return <general.HidePassword {...props} />;
    case Name.GENERAL_PLANS_CHECK_MARK:
      return <general.PlansCheckMark {...props} />;
    case Name.GENERAL_PRICING_TABLE_INFO:
      return <general.PricingTableInfo {...props} width={20} height={20} />;
    case Name.GENERAL_PRICING_TABLE_CHECK_MARK:
      return (
        <general.PricingTableCheckMark {...props} width={20} height={20} />
      );
    case Name.GENERAL_PRICING_TABLE_CROSS:
      return <general.PricingTableCross {...props} width={20} height={20} />;
  }
};

const IconBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Icon: React.FC<IIcon> = (props) => {
  const SvgRef = useRef(null);

  useEffect(() => {
    if (props.color && SvgRef?.current) {
      const svgEl = SvgRef.current.firstChild;
      const svgChilds = Array.from(svgEl.children);
      svgChilds.forEach((svgChild: SVGElement) => {
        if (svgChild.hasAttribute('fill')) {
          svgChild.style.fill = props.color;
        }
        if (svgChild.hasAttribute('stroke')) {
          svgChild.style.stroke = props.color;
        }
      });
    }
  }, [SvgRef]);

  return (
    <IconBox ref={SvgRef}>
      <IconByName {...props} />
    </IconBox>
  );
};
